import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-fela'
import Icon from 'views/components/presentationals/Icon'
import NavBarLink from 'views/components/presentationals/NavBarLink'
import NavBarButton from 'views/components/presentationals/NavBarButton'
import NavBarLabel from 'views/components/presentationals/NavBarLabel'
import NavBarDropdown from 'views/components/presentationals/NavBarDropdown'
import DeliveryButton from 'views/components/smart/DeliveryButton'
import ds from 'views/styles/designSystem'
import { pxTo } from 'design-system-utils'
import { injectIntl } from 'react-intl'
import { TYPES } from 'constants/user'

class NavBar extends PureComponent {
  constructor(props) {
    super(props)

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    if (e.target.value) {
      this.props.history.push(e.target.value)
    }
  }

  render() {
    const {
      isGranted,
      authenticated,
      userType,
      accessWhiteLabel,
      canDropOffDeliveries,
      styles,
      location,
      intl,
    } = this.props
    const isAdmin = isGranted(true)

    const isDeliveries = (match, location) => {
      if (location.pathname.match(/^\/deliveries\/.*?/)) {
        return true
      }

      return false
    }
    const newDeliveryButton = {
      type: DeliveryButton,
      props: {
        to: '/delivery',
        exact: true,
        style: {
          marginRight: pxTo(10, ds.get('type.baseFontSize'), 'rem'),
        },
      },
      children: intl.formatMessage({ id: 'layouts.navbar.newDelivery' }),
    }
    const registerLink = {
      type: NavBarButton,
      props: {
        to: '/register',
        exact: true,
        outline: true,
        brand: 'secondary',
      },
      children: intl.formatMessage({ id: 'layouts.navbar.toRegister' }),
    }
    const askNoAccountLink = {
      type: NavBarLabel,
      children: intl.formatMessage({ id: 'layouts.navbar.askNoAccount' }),
    }
    const askAlreadyAnAccountLink = {
      type: NavBarLabel,
      children: intl.formatMessage({ id: 'layouts.navbar.askAlreadyAnAccount' }),
    }
    const loginLink = {
      type: NavBarButton,
      props: {
        to: '/login',
        exact: true,
      },
      children: intl.formatMessage({ id: 'layouts.navbar.toLogin' }),
    }
    const adminLink = {
      type: NavBarLink,
      props: {
        to: '/admin',
        exact: true,
        activeClassName: 'active',
      },
      children: intl.formatMessage({ id: 'layouts.navbar.admin' }),
    }
    const onGoingLink = {
      type: NavBarLink,
      props: {
        to: '/deliveries/ongoing',
        activeClassName: 'active',
        isActive: isDeliveries,
      },
      children: intl.formatMessage({ id: 'layouts.navbar.myDeliveries' }),
    }
    const rideLink = {
      type: NavBarLink,
      props: {
        to: '/ride',
        activeClassName: 'active',
      },
      children: intl.formatMessage({ id: 'layouts.navbar.ride' }),
    }
    const favouritesLink = {
      type: NavBarLink,
      props: {
        to: '/favourites',
        exact: true,
        activeClassName: 'active',
      },
      children: intl.formatMessage({ id: 'layouts.navbar.favourites' }),
    }
    const archivesLink = {
      type: NavBarLink,
      props: {
        to: '/archives',
        exact: true,
        activeClassName: 'active',
      },
      children: intl.formatMessage({ id: 'layouts.navbar.myArchives' }),
    }
    const newDeliveryLink = {
      type: NavBarLink,
      props: {
        to: '/delivery',
        exact: true,
        className: styles.mobile,
        style: {
          marginRight: pxTo(10, ds.get('type.baseFontSize'), 'rem'),
        },
      },
      children: intl.formatMessage({ id: 'layouts.navbar.newDelivery' }),
    }
    const proposalsSearchLink = {
      type: NavBarLink,
      props: {
        to: '/proposals/scheduled',
        activeClassName: 'active',
      },
      children: intl.formatMessage({ id: 'layouts.navbar.myProposals' }),
    }
    const myVehiclesLink = {
      type: NavBarLink,
      props: {
        to: '/vehicles',
        exact: true,
        activeClassName: 'active',
      },
      children: intl.formatMessage({ id: 'layouts.navbar.vehicles' }),
    }
    const myCouriersLink = {
      type: NavBarLink,
      props: {
        to: '/couriers',
        exact: true,
        activeClassName: 'active',
      },
      children: intl.formatMessage({ id: 'layouts.navbar.couriers' }),
    }
    const operationsLink = {
      type: NavBarLink,
      props: {
        to: '/operations',
        exact: true,
        style: {
          marginRight: pxTo(10, ds.get('type.baseFontSize'), 'rem'),
        },
      },
      children: intl.formatMessage({ id: 'layouts.navbar.operations' }),
    }
    const geolocationOperationsLink = {
      type: NavBarLink,
      props: {
        to: '/operations/geolocation',
        exact: true,
        style: {
          marginRight: pxTo(10, ds.get('type.baseFontSize'), 'rem'),
        },
      },
      children: intl.formatMessage({ id: 'layouts.navbar.geolocation' }),
    }

    const mapLink = {
      type: NavBarLink,
      props: {
        to: '/map',
        exact: true,
        activeClassName: 'active',
      },
      children: intl.formatMessage({ id: 'layouts.navbar.map' }),
    }

    const whiteLabelLink = {
      type: NavBarLink,
      props: {
        to: '/white-label',
        exact: true,
        activeClassName: 'active',
      },
      children: intl.formatMessage({ id: 'layouts.navbar.white_label' }),
    }

    const invoicesLink = {
      type: NavBarLink,
      props: {
        to: '/invoices',
        exact: true,
        activeClassName: 'active',
      },
      children: intl.formatMessage({ id: 'layouts.navbar.invoices' }),
    }
    const elements = []
      .concat(!authenticated && location.pathname === '/register' ? [askAlreadyAnAccountLink, loginLink] : [])
      .concat(!authenticated && location.pathname === '/login' ? [askNoAccountLink, registerLink] : [])
      .concat(!authenticated && !['/register', '/login'].includes(location.pathname) ? [registerLink, loginLink] : [])
      .concat(isAdmin ? [adminLink] : [])
      .concat(
        authenticated && [TYPES.FREIGHT_FORWARDER].includes(userType)
          ? [onGoingLink, archivesLink, newDeliveryButton, newDeliveryLink]
          : [],
      )
      .concat(authenticated && [TYPES.COMPANY_COURIER].includes(userType) ? [] : [])
      .concat(
        authenticated && [TYPES.INDEPENDENT_COURIER].includes(userType)
          ? [rideLink, archivesLink, ...(canDropOffDeliveries ? [newDeliveryButton, newDeliveryLink] : [])].filter(
              Boolean,
            )
          : [],
      )
      .concat(
        authenticated && [TYPES.OPERATOR].includes(userType)
          ? [
              operationsLink,
              geolocationOperationsLink,
              proposalsSearchLink,
              favouritesLink,
              mapLink,
              archivesLink,
              ...(canDropOffDeliveries ? [newDeliveryButton, newDeliveryLink] : []),
            ]
          : [],
      )
      .concat(authenticated && [TYPES.ACCOUNTANT].includes(userType) ? [operationsLink, invoicesLink] : [])
      .concat(
        authenticated && [TYPES.MANAGER].includes(userType)
          ? [
              proposalsSearchLink,
              onGoingLink,
              archivesLink,
              rideLink,
              myVehiclesLink,
              myCouriersLink,
              ...(accessWhiteLabel ? [whiteLabelLink] : []),
              ...(canDropOffDeliveries ? [newDeliveryButton, newDeliveryLink] : []),
            ].filter(Boolean)
          : [],
      )
      .concat(
        authenticated
          ? [
              {
                type: NavBarDropdown,
                props: {
                  links: [
                    {
                      label: intl.formatMessage({ id: 'layouts.navbar.dropdown.account' }),
                      href: '/account',
                    },
                    ...([TYPES.COMPANY_COURIER, TYPES.ACCOUNTANT].includes(userType)
                      ? []
                      : [
                          {
                            label: intl.formatMessage({ id: 'layouts.navbar.dropdown.vouchers' }),
                            href: '/vouchers',
                          },
                          {
                            label: intl.formatMessage({ id: 'layouts.navbar.dropdown.company' }),
                            href: '/company',
                          },
                          {
                            label: intl.formatMessage({ id: 'layouts.navbar.dropdown.bank' }),
                            href: '/bank',
                          },
                        ]),
                    // ...([TYPES.MANAGER].includes(userType)
                    //   ? [
                    //       {
                    //         label: intl.formatMessage({ id: 'layouts.navbar.dropdown.profitability' }),
                    //         href: '/profitability-calculation',
                    //       },
                    //     ]
                    //   : []),
                    ...(process.env.ENABLE_CUSTOM_PAGE === '1' && [TYPES.FREIGHT_FORWARDER].includes(userType)
                      ? [
                          {
                            label: intl.formatMessage({ id: 'layouts.navbar.dropdown.customize' }),
                            href: '/customize',
                          },
                        ]
                      : []),
                    {
                      label: intl.formatMessage({ id: 'layouts.navbar.dropdown.help' }),
                      href: '/help',
                    },
                    {
                      label: intl.formatMessage({ id: 'layouts.navbar.dropdown.logout' }),
                      href: '/logout',
                    },
                  ],
                },
              },
            ]
          : [],
      )

    return [
      <nav className={styles.desktop} key="desktop">
        {elements.map((element, index) =>
          React.createElement(element.type, { ...element.props, key: index }, element.children || null),
        )}
      </nav>,
      <label className={styles.mobile} htmlFor="navbar-mobile" key="mobile">
        <select
          id="navbar-mobile"
          className={styles.select}
          value=""
          onChange={this.handleChange}
          onBlur={this.handleChange}
        >
          <option value="" disabled>
            {intl.formatMessage({ id: 'layouts.navbar.select' })}
          </option>
          {elements.map((element, index) => {
            /* eslint-disable eqeqeq */
            if (element.type == NavBarLink) {
              return (
                <option value={element.props.to} key={index}>
                  {element.children}
                </option>
              )
            } else if (element.type == NavBarButton) {
              return (
                <option value={element.props.to} key={index}>
                  {element.children}
                </option>
              )
            } else if (element.type == NavBarLabel) {
              return <optgroup label={element.children} key={index} />
            } else if (element.type == NavBarDropdown) {
              return [
                <optgroup label={intl.formatMessage({ id: 'layouts.navbar.dropdown.title' })} key="more" />,
                ...element.props.links.map((link, index) => (
                  <option value={link.href} key={index}>
                    {link.label}
                  </option>
                )),
              ]
            }
            /* eslint-disable eqeqeq */
          })}
        </select>
        <Icon name="menu" className={styles.icon} />
      </label>,
    ]
  }
}

NavBar.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  isGranted: PropTypes.func.isRequired,
  userType: PropTypes.string,
  accessWhiteLabel: PropTypes.bool.isRequired,
  canDropOffDeliveries: PropTypes.bool.isRequired,
  styles: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  intl: PropTypes.object.isRequired,
}

const rules = {
  desktop: () => ({
    height: pxTo(80, ds.get('type.baseFontSize'), 'rem'),
    display: 'none',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: ds.brand('white'),
    '> a button': {
      marginLeft: pxTo(20, ds.get('type.baseFontSize'), 'rem'),
    },
    '> div:last-child': {
      marginLeft: pxTo(20, ds.get('type.baseFontSize'), 'rem'),
    },
    '@media (min-width: 768px)': {
      display: 'flex',
    },
  }),
  mobile: () => ({
    position: 'relative',
    display: 'inline-block',
    '@media (min-width: 768px)': {
      display: 'none',
    },
  }),
  select: () => ({
    position: 'absolute',
    opacity: 0,
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    appearance: 'none',
    border: 'none',
    cursor: 'pointer',
  }),
  icon: () => ({
    color: ds.get('colors.white'),
  }),
}

export default injectIntl(withRouter(connect(rules)(NavBar)))
